import React, { useState } from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { SHOP_URL } from '../../data/ribbonData';

const Swatch = ({ c, active, onClick, id }) => (
  <button onClick={onClick} title={c.name} aria-label={c.name} data-testid={id}
    className={`w-9 h-9 rounded-full border border-white/20 transition-transform duration-200 hover:scale-110 ${active ? 'scale-110 rb-ring' : ''}`}
    style={{ background: c.bp ? `linear-gradient(135deg, ${c.hex} 55%, #111 55%)` : c.hex }} />
);

export const RibbonShop = ({ id, size, title, blurb, colors, perks, reverse }) => {
  const [idx, setIdx] = useState(0);
  const c = colors[idx];
  return (
    <section id={id} className="relative max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-24" data-testid={`${id}-section`}>
      <div className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-start ${reverse ? 'lg:[&>*:first-child]:order-2' : ''}`}>
        <div className="lg:sticky lg:top-28 min-w-0">
          <div className="relative">
            <div className="absolute -inset-4 rounded-[2.5rem] blur-2xl opacity-60 transition-colors duration-500" style={{ background: c.hex }} />
            <div className="relative rounded-[2rem] overflow-hidden rb-glass p-2 aspect-square">
              <img key={c.img} src={c.img} alt={`${size} ${c.name} ribbon`} className="w-full h-full object-cover rounded-[1.6rem] rb-fade" data-testid={`${id}-main-image`} />
              <span className="absolute top-5 left-5 rounded-full rb-btn text-xs font-bold uppercase tracking-wider px-4 py-1.5">{size} wide</span>
            </div>
          </div>
          <div className="flex gap-3 overflow-x-auto scrollbar-hide mt-5 pb-1">
            {colors.map((col, i) => (
              <button key={col.name} onClick={() => setIdx(i)} data-testid={`${id}-thumb-${i}`}
                className={`flex-shrink-0 w-16 h-16 rounded-xl overflow-hidden border transition-opacity ${i === idx ? 'border-[#ff6a00] shadow-[0_0_14px_#ff6a00]' : 'border-white/10 opacity-50 hover:opacity-100'}`}>
                <img src={col.img} alt={col.name} loading="lazy" className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        </div>
        <div className="min-w-0">
          <p className="rb-eyebrow mb-4">{size} satin ribbon · {colors.length} colors</p>
          <h2 className="rb-head text-5xl sm:text-6xl lg:text-7xl mb-5 rb-neon">{title}</h2>
          <p className="text-white/70 text-base sm:text-lg leading-relaxed mb-8">{blurb}</p>
          <div className="rb-glass rounded-3xl p-6 sm:p-8">
            <div className="flex items-baseline justify-between mb-5">
              <p className="text-sm text-white/50 uppercase tracking-widest">Color</p>
              <p className="rb-head text-2xl rb-grad" data-testid={`${id}-selected-color`}>{c.name}</p>
            </div>
            <div className="flex flex-wrap gap-3 mb-8" data-testid={`${id}-swatches`}>
              {colors.map((col, i) => <Swatch key={col.name} c={col} active={i === idx} onClick={() => setIdx(i)} id={`${id}-swatch-${i}`} />)}
            </div>
            <a href={SHOP_URL} target="_blank" rel="noopener noreferrer" data-testid={`${id}-shop-btn`}
              className="group w-full inline-flex items-center justify-center gap-2 rounded-full rb-btn py-4 font-bold uppercase tracking-wider">
              Shop {size} {c.name} <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </a>
            <ul className="mt-6 grid sm:grid-cols-3 gap-3 text-sm text-white/70">
              {perks.map((p) => <li key={p} className="flex items-center gap-2"><Check className="w-4 h-4 text-[#ff8a00]" />{p}</li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
